<template>
	<the-transition v-bind="$attrs">
		<slot></slot>
	</the-transition>
</template>

<script>
	import { TransitionSlide as TheTransition } from '@morev/vue-transitions';

	export default {
		name: 'TransitionSlide',
		inheritAttrs: false,
		components: { TheTransition },
	};
</script>
